import React from 'react';
import { theme } from '../theme';
import './Access.css';

const Access = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Accesos e Información</h1>
        <p className="page-intro">
          Aquí encontrarás toda la información para acceder al departamento.
        </p>
      </div>

      <div className="page-content">
        <section className="page-section section-gradient-left">
          <h2>Instrucciones de Acceso</h2>
          <ul className="access-list">
            <li className="list-item">El edificio cuenta con seguridad 24/7.</li>
            <li className="list-item">Para entrar, muestra tu identificación en recepción.</li>
            <li className="list-item">Usa el código de acceso enviado previamente para abrir la puerta.</li>
            <li className="list-item">El departamento se encuentra en el piso 4, al fondo.</li>
          </ul>
        </section>

        <section className="page-section section-gradient-right">
          <h2>Ubicación</h2>
          <p className="list-item" style={{ marginBottom: '1rem' }}>
            Privada Chinela No. 15, Int. 10.<br />
            C.P. 78295 Torre Volterra.<br />
            San Luis Potosí, SLP.
          </p>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d118283.83099441411!2d-101.005597!3d22.111875!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842a990550d35e6b%3A0xfa811dbeffe33a13!2sVOLTERRA!5e0!3m2!1sen!2smx!4v1747690868231!5m2!1sen!2smx"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación del departamento"
            ></iframe>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Access; 